import {ILocationService, ILogService} from "angular";
import {NotificationsService} from "../notifications.service";
import "./notifications-button.less";
import {User} from "../../model/User";

class NotificationsButtonController {

    private notifications = [];
    private hasUnseen = false;
    private loading = true;
    private user: User;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $location: ILocationService,
                private notificationsService: NotificationsService) {
    }

    public $onInit() {
        this.notificationsService.subscribe(this.user.username, (notifications) => {
            this.notifications = notifications;
            this.hasUnseen = notifications.some((notification) => !notification.seen);
            this.loading = false;
        });
    }

    public $onDestroy() {
        this.notificationsService.unsubscribe(this.user.username);
    }

    public goTo(notification) {
        this.notificationsService.markSeen(this.user.username, notification)
            .then(() => this.$location.path(notification.link));
    }
}

export const NotificationsButtonComponent: angular.IComponentOptions = {
    bindings: {
        user: "<"
    },
    controller: NotificationsButtonController,
    template: require("./notifications-button.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/notifications/button/notifications-button.component.ts